export const hasValue = (x) => x && x !== 'Invalid date'
